import { createSelector } from '@ngrx/store';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, MmsAdminState } from './mms-admin-override.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';

const getState = createSelector(getManagementState, (state: ManagementState) => state.mmsAdmin);
const getLocations = createSelector(getState, (state: MmsAdminState) => state.locations);
const getTemplateOptionsByLocation = createSelector(getState, (state: MmsAdminState) => state.templateOptionsByLocation);
const getTemplateByLocation = createSelector(getState, (state: MmsAdminState) => state.templateByLocation);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelected = createSelector(getState, (state: MmsAdminState) => state.selected);
const getSavedSelections = createSelector(getState, (state: MmsAdminState) => state.selections);
const getSearchFilter = createSelector(getState, (state: MmsAdminState) => state.searchFilter);
const getFilteredItems = createSelector(
    getLocations,
    getSearchFilter,
    (locations: any[], filter: SearchFilter) => {

        const filterString = Array.isArray(filter?.value)
            ? (filter?.value as string[]).join(',').toLowerCase()
            : filter?.value
                ? (filter?.value.toLowerCase() as string)
                : '';

        const newObject = locations.map((location) => {
            return {
                ...location,
                name:  location.name + ` (${location.tag})`
            };
        });
        return newObject.filter(option => option.name.toLowerCase().includes(filterString));
    }
);

export const MmsAdminSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelected,
    getSavedSelections,
    getSearchFilter,
    getFilteredItems,
    getLocations,
    getTemplateOptionsByLocation,
    getTemplateByLocation,
};
